<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.02.11</b> - В основном исправления багов и ИИ :)</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Добавлен опциональный фильтр ненормативной лексики для чата.</li>
      <li>Добавлена кнопка "Пропустить обучение".</li>
      <li>Подсказки Свеча молитвы теперь указывают на выравнивание свечи.</li>
      <li>
        Баланс: нерф стоимости ОД для Тупоконечная стрела:
        <code>50 - Уровень*2</code> --> <code>80 - Уровень*2</code>
      </li>
      <li>
        ИИ
        <ul>
          <li>
            - Юниты теперь нацеливаются на врагов с наименьшим ЭФФЕКТИВНЫМ здоровьем (ОЗ * Armor
            Class), а не просто с наименьшим ОЗ.
          </li>
          <li>
            - Способности призыва больше не принадлежат к дереву Support. Вместо этого они
            рассматриваются как самобафы, что теперь является отдельным деревом, которое проверяется перед
            водопадом ролей.
          </li>
          <li>- Юниты не будут пропускать ход в ожидании МС для применения баффа.</li>
          <li>
            - Деревья Tank и DPS Close теперь полностью игнорируются "чисто дальними"
            юнитами (т.е. у которых Ranged DPS приоритетнее обоих, и нет экипированных способностей ближнего боя).
          </li>
          <li>
            - Герои ближнего боя теперь будут использовать Добивание только если это убьёт цель.
          </li>
          <li>- Исправлен баг, заставлявший юнитов с Прыжок прыгать случайным образом.</li>
          <li>- Юниты Interference больше не будут оглушать испуганную цель</li>
          <li>- Теперь никто нигде никогда не будет нацеливаться на призванного юнита для лечения.</li>
        </ul>
      </li>
      <li>
        Баги
        <ul>
          <li>- Исправлен баг с ИИ Добивание, отображающий призрачный урон.</li>
          <li>- Исправлен возврат стоимости ОД для Добивание.</li>
          <li>- Исправлен баг, при котором оружие не срабатывало от Небесный молот.</li>
          <li>- Исправлен баг отрисовки лута Пещеры после переключения вкладок туда и обратно.</li>
          <li>- Исправлен баг, позволяющий атаки Таверна при отсутствии вызовов.</li>
          <li>- Исправлена раскладка иконок предметов в модальном окне Battle Debrief.</li>
          <li>- Исправлено отображение иконок красителей в инвентаре и магазине.</li>
          <li>- Исправлен баг, снижающий производительность Пещеры при заполнении лога.</li>
          <li>- Исправлен баг, затрудняющий клик по голым героям.</li>
          <li>- Исправлено форматирование валюты и отображения ОЗ/ОД/МС.</li>
          <li>- Исправлен спам в логе сообщений при переключении вкладок туда и обратно.</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
